<template>
  <div class="block-t">
    <div class="block-t__content">
      <div class="block-t__letter letter letter-line" data-aos="fade-up">
        Т.
      </div>
      <div class="block-t__image rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4">
        <img src="../assets/img/block-t-1-m.png" alt="">
      </div>
      <div class="block-t__info" data-aos="fade-up">
        <div class="block-t__title">Теат<span>[р]</span></div>
        <div class="block-t__text text text-white">Заветной мечтой Вертинского с детства было поступить <br>в Московский художественный театр. Но ей не суждено было сбыться. В 1913 году Вертинский провалил вступительные испытания из-за дефекта дикции: <br><span></span>не кто-нибудь, а сам К. С. Станиславский, принимавший экзамен, заявил, что с таким плохим звуком [р], <br>путь в МХТ закрыт.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-t
      padding-bottom: vwm(220px)
      &__content
        flex-direction: column
      &__image
        width: vwm(374px)
        margin-left: vwm(-27px)
        margin-top: vwm(-24px)
        img
        &:after
          display: none
      &__letter
        margin-left: vwm(-5px)
        position: relative
        z-index: 100
        margin-top: vwm(79px)
      &__text
        margin-left: vwm(18px)
        margin-top: vwm(58px)
        width: 90vw
        span
          display: block
        br
          display: none
      &__title
        font-size: vwm(70px)
        text-align: center
        margin-left: 0
        margin-right: 0
        padding-left: 0
        padding-right: 0
        span
      &__info
        margin-left: vwm(-29px)
        margin-top: vwm(-83px)
</style>
